const products = state => state.products;

export default {
  products,
};



// WEBPACK FOOTER //
// ./src/store/modules/products/getters.js